import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import Integracoes from "@/pages/Integracoes";

export const Route = createFileRoute("/integracoes")({
  head: () => buildHead({
    title: "Integrações da OP2P CRM: HubSpot, RD Station, Hotmart e mais | OP2P",
    description: "Veja todas as integrações da OP2P CRM: HubSpot, RD Station, Hotmart, Shopify, WooCommerce, Pipedrive e outras, conectadas ao WhatsApp, Instagram e Agentes de IA.",
    path: "/integracoes",
  }),
  component: Integracoes,
});
